import { Grid } from "@mui/material";
import { styled } from "@mui/system";

export const ChatWrapper = styled(Grid)(() => ({
  display: "flex",
  flexWrap: "nowrap",
  justifyContent: "space-between",
  width: "100%",
}));
